<template>
    <div class="">
        <banner type="4"></banner>
        <productList :recommend-show="false" :product-list="customizedServicesList" product-name="Services"></productList>
    </div>
</template>

<script>
    import productList from "../ENComponents/productList";

    export default {
        name: 'customizedServices',
        props: {},
        components: {
            productList
        },
        data() {
            return {
                customizedServicesList: [],
            }
        },
        async mounted() {
            this.getCustomizedServicesList()
        },
        methods: {
            // 获取定制服务
            async getCustomizedServicesList() {
                this.customizedServicesList = await this.$api.getCustomizedServicesList()
            }
        },

    }
</script>
<style scoped lang="scss">
    .nav {
        height: 100px;
        width: 100%

    }
</style>
